/* ---------- global stacking container ---------- */
.toast-stack {
  position: fixed;
  bottom: 1.15rem;
  right: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
  pointer-events: none;
  z-index: 10500;
}

.toast {
  pointer-events: auto;
  width: 450px;
}

.etex-toast-download {
  color: var(--fdt-semantic-color-foreground-active) !important;
}

/* ---------- Animations ---------- */
@keyframes slide-in {
  from {
    transform: translateX(110%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-out {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(110%);
    opacity: 0;
  }
}
.toast--enter {
  animation: slide-in 0.35s forwards ease;
}

.toast--exit {
  animation: slide-out 0.35s forwards ease;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiQzpcXGlvXFxldGV4LWh1YnN0ZXJcXHNyY1xcRnJvbnRlbmRcXGhlYWRsZXNzXFxtb2R1bGVzXFxldGV4XFxzcmNcXGNvbXBvbmVudHNcXHRvYXN0Iiwic291cmNlcyI6WyJ0b2FzdC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBO0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7QUFDQTtFQUNFO0lBQ0U7SUFDQTs7RUFFRjtJQUNFO0lBQ0E7OztBQUlKO0VBQ0U7SUFDRTtJQUNBOztFQUVGO0lBQ0U7SUFDQTs7O0FBSUo7RUFDRTs7O0FBR0Y7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIiR0b2FzdC1hbmltLWR1cmF0aW9uOiAwLjM1cztcclxuXHJcbi8qIC0tLS0tLS0tLS0gZ2xvYmFsIHN0YWNraW5nIGNvbnRhaW5lciAtLS0tLS0tLS0tICovXHJcbi50b2FzdC1zdGFjayB7XHJcbiAgcG9zaXRpb246IGZpeGVkO1xyXG4gIGJvdHRvbTogMS4xNXJlbTtcclxuICByaWdodDogMXJlbTtcclxuICBkaXNwbGF5OiBmbGV4O1xyXG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XHJcbiAgYWxpZ24taXRlbXM6IGZsZXgtZW5kO1xyXG4gIGdhcDogMC41cmVtO1xyXG4gIHBvaW50ZXItZXZlbnRzOiBub25lO1xyXG4gIHotaW5kZXg6IDEwNTAwO1xyXG59XHJcblxyXG4udG9hc3Qge1xyXG4gIHBvaW50ZXItZXZlbnRzOiBhdXRvO1xyXG4gIHdpZHRoOiA0NTBweDtcclxufVxyXG5cclxuLmV0ZXgtdG9hc3QtZG93bmxvYWQge1xyXG4gIGNvbG9yOiB2YXIoLS1mZHQtc2VtYW50aWMtY29sb3ItZm9yZWdyb3VuZC1hY3RpdmUpICFpbXBvcnRhbnQ7XHJcbn1cclxuXHJcbi8qIC0tLS0tLS0tLS0gQW5pbWF0aW9ucyAtLS0tLS0tLS0tICovXHJcbkBrZXlmcmFtZXMgc2xpZGUtaW4ge1xyXG4gIGZyb20ge1xyXG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDExMCUpO1xyXG4gICAgb3BhY2l0eTogMDtcclxuICB9XHJcbiAgdG8ge1xyXG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDApO1xyXG4gICAgb3BhY2l0eTogMTtcclxuICB9XHJcbn1cclxuXHJcbkBrZXlmcmFtZXMgc2xpZGUtb3V0IHtcclxuICBmcm9tIHtcclxuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgwKTtcclxuICAgIG9wYWNpdHk6IDE7XHJcbiAgfVxyXG4gIHRvIHtcclxuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgxMTAlKTtcclxuICAgIG9wYWNpdHk6IDA7XHJcbiAgfVxyXG59XHJcblxyXG4udG9hc3QtLWVudGVyIHtcclxuICBhbmltYXRpb246IHNsaWRlLWluICR0b2FzdC1hbmltLWR1cmF0aW9uIGZvcndhcmRzIGVhc2U7XHJcbn1cclxuXHJcbi50b2FzdC0tZXhpdCB7XHJcbiAgYW5pbWF0aW9uOiBzbGlkZS1vdXQgJHRvYXN0LWFuaW0tZHVyYXRpb24gZm9yd2FyZHMgZWFzZTtcclxufVxyXG4iXX0= */